import React from 'react';
import './styles/kontakt.css';
import kontaktHero from '../images/image1.jpg';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import ContactForm from '../components/contactForm';

function Kontakt() {
  React.useEffect(() => {
    // Check om der er en hash i URL'en
    if (window.location.hash === '#kontaktformular') {
      setTimeout(() => {
        document.getElementById('kontaktformular')?.scrollIntoView({ 
          behavior: 'smooth' 
        });
      }, 100);
    }
  }, []);

  return (
    <>
      <div className="kontakt-hero">
        <img src={kontaktHero} alt="Kontakt Byggeriets Partner" className="kontakt-hero-image" />
      </div>

      <section className="kontakt-info">
        <div className="kontakt-container">
          <div className="kontakt-intro">
            <span className="kontakt-overline">Kontakt os</span>
            <h2>Lad os tale om jeres behov</h2>
            <p className="kontakt-intro-text">
              Vi er klar til at hjælpe jer med at optimere jeres dokumentationsprocesser. 
              Uanset om det drejer sig om kvalitetssikring, DS1140 eller drift & vedligehold, 
              finder vi sammen den bedste løsning for jer.
            </p>
          </div>

          <div className="kontakt-grid">
            <div className="kontakt-card">
              <FaPhone className="kontakt-icon" />
              <h3>Ring til os</h3>
              <p>+45 42 41 16 33</p>
            </div>

            <div className="kontakt-card">
              <FaEnvelope className="kontakt-icon" />
              <h3>Skriv til os</h3>
              <p>info@byggerietspartner.dk</p>
            </div>

            <div className="kontakt-card">
              <FaMapMarkerAlt className="kontakt-icon" />
              <h3>Besøg os</h3>
              <p>Svebølle</p>
              <p>4470 Kalundborg</p>
            </div>
          </div>
        </div>
      </section>

      <section className="drift-section">
        <div className="section-content">
          <div className="contact-section">
            <div className="contact-content">
              <div className="contact-header">
                <span className="overline">Kontakt os</span>
                <h3>Lad os tale om jeres behov</h3>
                <p className="contact-intro">
                  Vi hjælper jer med at optimere jeres byggeprojekter gennem professionel kvalitetssikring og drift & vedligehold.
                </p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Kontakt;
